<header class="header">
  <div class="header__container">
    <img routerLink="/home" class="header__logo" src="/assets/images/svg/Ignite_LogoBlanco.png" alt="">

    <div class="initial-login">
      
      <img src="/assets/icons/icon-ubicacion.svg"/>
      <select #site *ngIf="true" (change)="changeSite(site.value)"
        style="border-style: none; color:white; background: transparent; text-transform: uppercase;">
        <option [value]="0" class="option-color">{{all}}</option>
        <option *ngFor="let site of sites; trackBy: trackByMethod" value="{{site.id}}" [selected]="site.id == siteId" class="option-color">
          {{site.name}}
        </option>
      </select>
     
      <img src="/assets/icons/icon-idioma.svg"/>
      <select #langSelect (change)="changeLang(langSelect.value)" *ngIf="true" style="border-style: none; color:white;  background: transparent; text-transform: uppercase;">
        <option *ngFor="let lang of langs" [value]="lang" class="option-color">
          {{ lang }}
        </option>
      </select>

      <div>
        <img src="/assets/icons/icon-div.svg"/>
       </div>
   

      <div *ngIf="true" class="avatar dropdown">
        <span>{{userInitials}}</span>
        <div class="dropdown-content">
          <div class="dropdown-content-items">
            <div class="item-dropdown user_text">{{fullName}}</div>
            <div class="item-dropdown user_text">{{nameRol}}</div>

            <div class="item-dropdown">
              <button class="btn-form-control btn-logout" (click)="logout()" *ngIf="true">Logout</button>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="header__toggle" *ngIf="true" (click)="openMenu()" (mouseover)="openMenu()">
      <span id="header-toggle" class="cmx-icon-menu" aria-hidden="true"></span>
    </div>

  </div>
</header>

<div class="nav" id="navbar" *ngIf="true">
  <nav class="nav__container">
    <div class="nav__container-item">

      <div class="nav__list">
        <div class="nav__items">

          <ng-container *ngFor="let itemGroupMenu of menues">
            <div class="nav__dropdown" *ngIf="itemGroupMenu.parenT_MENU_ID === null" (click)="showSubmenu('submenu_'+itemGroupMenu.menU_ID)" id="submenu_{{itemGroupMenu.menU_ID}}">
              <a class="nav__link">                
                <span class="{{itemGroupMenu.icoN_PATH}} icon_menu" aria-hidden="true"></span>
                <span id="{{itemGroupMenu.menU_ID}}" class="nav__name">{{itemGroupMenu.name}}</span>
                <span class="cmx-icon-arrow-down-single" aria-hidden="true"></span>
              </a>
              <ng-container *ngFor="let itemSubGroupMenu of menues">
                <div class="nav__dropdown-collapse"
                  *ngIf="itemSubGroupMenu.parenT_MENU_ID !== null && itemSubGroupMenu.parenT_MENU_ID === itemGroupMenu.menU_ID">
                  <div class="nav__dropdown-content">
                    <a class="nav__dropdown-item" *ngIf="itemSubGroupMenu.parameters!==null" id="{{itemSubGroupMenu.menU_ID}}"
                      href="{{itemSubGroupMenu.url +'/'+itemSubGroupMenu.parameters }}">{{itemSubGroupMenu.name}}</a>
                    <a class="nav__dropdown-item" *ngIf="itemSubGroupMenu.parameters===null" id="{{itemSubGroupMenu.menU_ID}}"
                      [routerLink]="[itemSubGroupMenu.url]">{{itemSubGroupMenu.name}}</a>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="nav__container-item copyright">
      <div class="links-copyright-container">
        <hr>
        <div class="links-copyright">
          <a href="https://www.neoris.com/en/legal-notice" rel="noopener" target="_blank">Legal</a>
          <a href="https://www.neoris.com/en/privacy-policy" rel="noopener" target="_blank">Privacy</a>
          <a href="https://www.neoris.com" rel="noopener" target="_blank">neoris.com</a>
        </div>
      </div>
      <div class="copy-all">
        � NEORIS {{currentYear}}
      </div>
      <div class="copy">�</div>
    </div>
  </nav>
</div>
